export const setCookie = (name, value, time) => {
  if (name) {
    time = parseInt(time) || 60 * 60 * 24 * 7
    //https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
    document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; max-age=${time}; SameSite=Lax; path=/`
  } else {
    console.log(`Set cookie ${name} error`)
  }
}

export const getCookie = name => {
  const value = document.cookie.replace(
    // eslint-disable-next-line no-useless-escape
    new RegExp(
      '(?:(?:^|.*;)\\s*' +
        // eslint-disable-next-line no-useless-escape
        encodeURIComponent(name).replace(/[\-\.\+\*]/g, '\\$&') +
        '\\s*\\=\\s*([^;]*).*$)|^.*$'
    ),
    '$1'
  )
  return decodeURIComponent(value) || null
}

export const getRandomInt = (min, max) => {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}

export const formatAmount = num => {
  if (!isNaN(num)) {
    const arr = num.toString().split('.')
    if (arr[1]) {
      const tmp = Number(0 + '.' + arr[1]).toFixed(2)
      return arr[0].toString().replace(/\d+?(?=(?:\d{3})+$)/gim, '$&,') + '.' + tmp.toString().split('.')[1]
    } else {
      return arr[0].toString().replace(/\d+?(?=(?:\d{3})+$)/gim, '$&,')
    }
  } else {
    return ''
  }
}

export const formatTime = val => {
  if (val < 3600) {
    const min = Math.floor(val / 60) < 10 ? '0' + Math.floor(val / 60) : Math.floor(val / 60)
    const sec = Math.floor(val % 60) < 10 ? '0' + Math.floor(val % 60) : Math.floor(val % 60)
    return min + ':' + sec
  } else if (val >= 3600) {
    const hour = Math.floor(val / 3600) < 10 ? '0' + Math.floor(val / 3600) : Math.floor(val / 3600)
    const min = Math.floor((val % 3600) / 60) < 10 ? '0' + Math.floor((val % 3600) / 60) : Math.floor((val % 3600) / 60)
    const sec = Math.floor(val % 60) < 10 ? '0' + Math.floor(val % 60) : Math.floor(val % 60)
    return hour + ':' + min + ':' + sec
  }
}

export const getBrowser = function() {
  const ua = window.navigator.userAgent || ''
  const isAndroid = /android/i.test(ua)
  const isIos = /iphone|ipad|ipod/i.test(ua)
  const systemInfo = /Android [\d.]*/i.exec(ua)
  const browserInfo = /Chrome\/[\d.]*/i.exec(ua)
  const browserVer = browserInfo ? parseFloat(browserInfo[0].split('/')[1]) : -1
  let androidVer = -1
  if (systemInfo) {
    if (systemInfo.includes('/')) {
      androidVer = parseFloat(systemInfo[0].split('/')[1])
    } else {
      androidVer = parseFloat(systemInfo[0].split(' ')[1])
    }
  }

  return {
    isAndroid,
    isIos,
    browserVer,
    androidVer,
    ua
  }
}

export const randomString = function(length) {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  var result = ''
  for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
  return result
}
export const animateCSS = function(element, animationName, callback) {
  const node = element

  function handleAnimationEnd() {
    node.classList.remove('animated', animationName)
    node.removeEventListener('animationend', handleAnimationEnd)
    node.removeEventListener('webkitAnimationEnd', handleAnimationEnd)

    if (typeof callback === 'function') callback()
  }

  node.addEventListener('animationend', handleAnimationEnd)
  node.addEventListener('webkitAnimationEnd', handleAnimationEnd)
  node.classList.add('animated', animationName)
}

export const copyClipboard = function(text, success, fail) {
  const input = document.createElement('input')
  input.setAttribute('readOnly', true)
  document.body.appendChild(input)
  input.setAttribute('value', text)
  input.select()
  const successful = document.execCommand('copy')
  document.body.removeChild(input)
  window.getSelection().removeAllRanges()

  if (successful) {
    success()
  } else {
    fail()
  }
}

/**
 *
 * @param {调用的方法名} func
 * @param {给调用方法传递的参数，格式是json模式} param
 */
export const jsBridge = async function(func, param) {
  if (window.getChannelId && window.getChannelId[func]) {
    if (param) {
      return window.getChannelId[func](JSON.stringify(param))
    } else {
      return window.getChannelId[func]()
    }
  } else if (window.iosBridge) {
    const iosUnSupportFunc = ['isLogin'] // ios不支持的方法，可以添加
    const pro = new Promise(function(resolve) {
      // https://github.com/marcuswestin/WebViewJavascriptBridge
      if (iosUnSupportFunc.includes(func)) {
        resolve(null)
      } else {
        window.iosBridge.callHandler(func, param, function(response) {
          resolve(response)
        })
      }
    })
    return await pro
  } else {
    return null
  }
}
